<template>
  <AppHeader fixed>
    <SidebarToggler class="d-lg-none" display="md" mobile />
    <div
      class="tophrpart d-none d-lg-inline-block"
      v-b-tooltip.hover
      :title="'Version: v' + getVersion"
    >
      <b-link class="navbar-brand" to="#" style="width: auto">
        <img src="/images/brand-mark-white_1.svg" style="height: 35px" alt="">
      </b-link>
    </div>
    <SidebarToggler class="d-none" :default-open="true" />

    <b-navbar-nav class="d-md-down-none">
      <slot />
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto">
      <b-button variant="info" class="mr-1 d-none d-sm-inline-block" :to="{name: 'Support.Tickets.Create'}"
      ><i class="fa fa-ticket"></i></b-button>
      <DefaultHeaderDropdownAccnt />
    </b-navbar-nav>
    <div class="asidetoggle-wrap d-none d-lg-block" @click="clickedToggler">
      <AsideToggler />
      <span class="badge badge-danger badge-pill" v-if="unreadCnt > 0">{{
        unreadCnt
      }}</span>
    </div>
  </AppHeader>
</template>
<script>
import { Header as AppHeader, SidebarToggler, AsideToggler } from '@coreui/vue';
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt';
import { mapGetters } from 'vuex';

export default {
  name: 'DefaultHeader',
  computed: {
    ...mapGetters(['getVersion'])
  },
  data() {
    return {
      unreadCnt: 0
    };
  },
  mounted() {
    this.loadUnreadCount();
  },
  methods: {
    loadUnreadCount() {
      this.$http
        .post('/api/common/notifications/count-uread', {})
        .then(resp => {
          this.unreadCnt = resp.data.unread;
        })
        .catch(err => {});
    },
    updateReadAll() {
      this.$http
        .post('/api/common/notifications/update-all-read', {})
        .then(resp => {
          this.unreadCnt = 0;
        })
        .catch(err => {});
    },
    clickedToggler() {
      this.unreadCnt = 0;
      this.updateReadAll();
    }
  },
  components: {
    AsideToggler,
    AppHeader,
    DefaultHeaderDropdownAccnt,
    SidebarToggler
  }
};
</script>
